/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/infra_dome_3': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M10.824 12h6.589v4.941h-6.589zM18.236 18.588h4.94l-3.294-2.47 3.294-2.471h-4.94zM10.824 17.766h.823V26h-.823z"/><g><path pid="1" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086H12V30h2.586L16 31.414 17.414 30H20v-2.25h7.75v-8.086L31.414 16l-3.664-3.664zm-.5-7.586v7.086L20.164 4.75h7.086zm-22.5 0h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zm9.55-.364V28h-.6v-4h.6v2.886zm2 1.114h-.6v-4h.6v4zm2-1.714V28h-.6v-4h.6v2.286zm8.95.964h-7.086l7.086-7.086v7.086zM20 24.586V22h-8v2.586L3.414 16 16 3.414 28.586 16 20 24.586z"/></g>'
  }
})
